import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ThemeConsumer from "../ThemeConsumer"

const Bullets = ({ className, theme, text, type }) => {
  const classes = classnames(theme.pv1, theme.ph4, theme.bullet, className, {
    [theme[type]]: type
  })

  return <span className={classes}>{text}</span>
}

Bullets.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.shape({
    pv1: PropTypes.string,
    ph3: PropTypes.string,
    ph4: PropTypes.string,
    bullet: PropTypes.string
  }),
  text: PropTypes.string,
  type: PropTypes.oneOf(["warning", "error", "success", "neutral"])
}

Bullets.defaultProps = {
  className: "",
  theme: {},
  text: "",
  type: "neutral"
}
export default ThemeConsumer("UIBullets")(Bullets)



// WEBPACK FOOTER //
// ./src/shared/components/Bullets/index.js